import React from 'react';
import PropTypes from 'prop-types';
import { graphql, createFragmentContainer } from 'react-relay';

// components
import ClockIcon from 'dibs-vg/dist/react/clock';
import PdpSharedBlurb from './PdpSharedBlurb/PdpSharedBlurb';
import { leadTimeTitle } from '../messages/pdpBlurbMessages';

// styles
import styles from './PdpSharedBlurbs.scss';

// helpers
import get from 'lodash.get';

// constants
import { ITEM_LEAD_TIME_AVAILABLE_NOW } from '../../constants/itemConstants';

export function PdpSharedBlurbLeadTime({ item }) {
    const leadTimeUrlLabel = get(item, 'attributes.leadTime[0].option.urlLabel');
    const leadTime = get(item, 'attributes.leadTime[0].option.name');
    const isAvailableNow = leadTimeUrlLabel === ITEM_LEAD_TIME_AVAILABLE_NOW;
    // hide Lead Time if it doesn't return [TIME], for example 4 - 5 weeks
    if (!leadTimeUrlLabel || isAvailableNow) {
        return null;
    }

    return (
        <PdpSharedBlurb Icon={ClockIcon}>
            <span className={styles.title}>{leadTimeTitle}: </span>
            {leadTime}
        </PdpSharedBlurb>
    );
}

PdpSharedBlurbLeadTime.propTypes = {
    item: PropTypes.object.isRequired,
};

export default createFragmentContainer(PdpSharedBlurbLeadTime, {
    item: graphql`
        fragment PdpSharedBlurbLeadTime_item on Item {
            attributes {
                leadTime {
                    option {
                        name
                        urlLabel
                    }
                }
            }
        }
    `,
});
